
/**
 * data-article-content コンテナから記事本文テキストを抽出・整形する
 */
export function extractArticleText(): string {
  console.log('[TTS] extractArticleText() called');
  
  const container = document.querySelector('[data-article-content]');
  if (!container) {
    console.error('[TTS] data-article-content container not found');
    return '';
  }
  
  console.log('[TTS] Container found:', container);

  const selectors = 'h1, h2, h3, h4, p, li';
  const elements = container.querySelectorAll(selectors);
  console.log(`[TTS] Found ${elements.length} elements matching "${selectors}"`);
  
  const lines: string[] = [];

  elements.forEach((el, idx) => {
    const text = (el.textContent || '').trim();
    if (!text) return;

    // 見出しは前後に改行を入れて区切る
    const tag = el.tagName.toLowerCase();
    if (/^h[1-4]$/.test(tag)) {
      lines.push(`\n${text}\n`);
    } else {
      lines.push(text);
    }
    
    // 最初の5要素だけログ出力
    if (idx < 5) {
      console.log(`[TTS] Element ${idx} (${tag}): "${text.slice(0, 50)}..."`);
    }
  });

  let result = lines.join('\n');
  console.log(`[TTS] Extracted text length (before normalization): ${result.length}`);
  console.log(`[TTS] Extracted text preview: "${result.slice(0, 200)}..."`);

  // URL行を削除
  result = result.replace(/^https?:\/\/.*$/gm, '');

  // 「参考リンク」「Sources」等の見出し以降をカット
  const cutoff = /^(G\)\s*)?(参考リンク|Sources|出典|引用元)\s*[:：]?\s*$/im;
  const match = cutoff.exec(result);
  if (match && match.index !== undefined) {
    console.log(`[TTS] Found cutoff pattern at index ${match.index}: "${match[0]}"`);
    result = result.slice(0, match.index);
  }

  // 連続改行は2つまで
  result = result.replace(/\n{3,}/g, '\n\n');

  const finalResult = result.trim();
  console.log(`[TTS] Normalized text length: ${finalResult.length}`);
  console.log(`[TTS] Normalized text preview: "${finalResult.slice(0, 200)}..."`);

  return finalResult;
}
